"use strict";

var app = angular.module('app');

app.directive('shoppingCartProductResume', function() {
    return {
        templateUrl: '/partials/directive/shopping-cart-product-resume.htm'
    };
});